<template>
  <div class="resourcePool">
    <!-- 顶部banner图 -->
    <div class="top-banner-box">
      <div class="top-banner-img">
        <div class="top-banner-center">
          <!-- <div class="wow animate__animated animate__zoomIn banner-btn" @click="onClickLookMore">资源池</div> -->
          <div class="btn-row">
            <div class="btn" @click="goDemandCollection">需求征集</div>
            <div class="btn" @click="tianbao">服务商入驻</div>
          </div>
        </div>
      </div>
      <!-- 服务商分类+服务分类+专家数 -->
      <div class="serviceCon">
        <div v-for="(item, index) in serviceInfo" :key="index" class="serviceItem">
          <div class="serviceItem-bg" :style="{ backgroundImage: `url(${item.icon})` }"></div>
          <div class="serviceItem-con">
            <div class="serviceItem-con-num">
              {{ item.num}}{{item.unit}}
              <span style="font-size:15px;color:#000;margin-left:2px"></span>
            </div>
            <div class="serviceItem-con-name">{{ item.name }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="module hot">
      <div class="module-title">热门需求</div>
      <div class="project-content">
        <div class="project-item" v-for="item in demandInfoList" :key="item.uuid">
          <div class="flag" :title="item.industryType"><span>{{item.industryType}}</span></div>
          <div class="title" :title="item.demandName">{{ item.demandName }}</div>
          <div class="text company" :title="item.companyName">需求方：{{ item.companyName }}</div>
          <div class="text">联系方式：{{setDimPhone(item.telPhone)}}</div>
          <div class="introduction">
            需求内容：{{item.remark}}
          </div>
          <div class="text">发布时间：{{ item.createDate }}</div>
          <div class="text">截止时间：{{formatDate(item.endDate)}}</div>
          <div class="text">预算金额：<span class="red-text">{{setBudGetText(item)}}</span></div>
          <div class="btn-row">
            <div class="btn" @click="goDetail(item)">查看详情</div>
          </div>
        </div>
      </div>
      <div class="more-btn" @click="goMorePage">更多需求</div>
    </div>
    <div class="module resource">
      <div class="img-list">
        <div class="img-item1"></div>
        <div class="img-item2"></div>
        <div class="img-item3"></div>
        <div class="img-item4"></div>
      </div>
      <serviceProvider2></serviceProvider2>
    </div>
    <demandInfoNews/>
  </div>
</template>

<script>
import {
  getDictionaryItem,
  getCount,
  getServiceSortCount,
  getServiceCount,
  getServiceIcon,
  getServiceProviderRecord
} from "../../utils/interface";
import demandInfoNews from "@/components/newsConsult/demandInfoNews";
import serviceProvider2 from "@/components/resourcePool/serviceProvider2";
import { demandInfoDataStatic, demandInfoQuery } from "@/utils/honorApi.js"
import { get } from "request";
import { setBudGetText, setDimPhone, formatDate } from "@/utils/filter";
export default {
  name: "",
  components: { demandInfoNews, serviceProvider2 },
  props: {},
  data() {
    return {
      headerBgUrl: "",
      serviceInfo: [
        {
          icon: require("../../assets/publicService/resourcePool/10.png"),
          name: "入驻服务商",
          num: 0,
          unit: '家'
        },
        {
          icon: require("../../assets/publicService/resourcePool/11.png"),
          name: "发布需求",
          num: 0,
          unit: '条'
        },
        {
          icon: require("../../assets/publicService/resourcePool/12.png"),
          name: "需求金额",
          num: 0,
          unit: '万元'
        },
        {
          icon: require("../../assets/publicService/resourcePool/12.png"),
          name: "响应需求",
          num: 0,
          unit: '次'
        }
      ],
      dataList: [],
      serviceList: [
        // { avatar: require('../../assets/publicService/resourcePool/21.png') },
        // { avatar: require('../../assets/publicService/resourcePool/22.png') },
        // { avatar: require('../../assets/publicService/resourcePool/23.png') }
      ],
      num: 168,
      profile:
        "汇聚一批不同行业、领域资深专家，充分发挥专家队伍的优势，为我区数字化\n" +
        "转型工作提供智力支持和技术保障，为政策制定、评估诊断、专项培训、供需\n" +
        "对接提供专业支撑，进一步促进我区新型工业化纵深发展",
      title: "",
      timer: null,
      demandInfoList: [],
    };
  },
  watch: {},
  computed: {},
  beforeRouteEnter(to, from, next) {
    // console.log("to=>", to)
    // console.log("from=>", from)
    // console.log("next=>", next)
    next(vm => {
      if (from.name == "expertDetail") {
        vm.$nextTick(() => {
          window.scrollTo({
            top: document.getElementById("field").offsetTop - 80,
            behavior: "smooth"
          });
        });
      }
    });
  },
  created() {
    this.getStatic();
    this.getDemandInfoList();
    // this.getOptionsData();
    // this.getServiceIcon(); // 获取服务商图标信息
  },
  mounted() {
    window.addEventListener("scroll", this.menu);
    if (this.$route.query.type || this.$route.query.code) {
      let type = this.$route.query.type;
      let code = this.$route.query.code;
      if (type == "expert" || code == "2") {
        this.timer = setInterval(() => {
          // 直到顶部导航栏加载出来，再去做滑动操作，防止滑动后顶部导航栏颜色还是透明色
          let length = document.querySelectorAll(".changeColor").length;
          if (length > 0) {
            clearInterval(this.timer);
            window.scrollTo({
              top: document.getElementById("field").offsetTop - 80,
              behavior: "smooth"
            });
          }
        });
      }
    }
    if (this.$route.query.title) {
      this.title = this.$route.query.title;
      this.timer = setInterval(() => {
        // 直到顶部导航栏加载出来，再去做滑动操作，防止滑动后顶部导航栏颜色还是透明色
        let length = document.querySelectorAll(".changeColor").length;
        if (length > 0) {
          clearInterval(this.timer);
          window.scrollTo({
            top: document.getElementById("field").offsetTop - 80,
            behavior: "smooth"
          });
        }
      });
    }
  },
  methods: {
    setBudGetText,
    setDimPhone,
    formatDate,
    goDetail(item) {
      this.$router.push({path: "/demandInfoDetail", query: { id: item.uuid }});
    },
    goMorePage() {
       this.$router.push("/demandInfoList");
    },
    goDemandCollection() {
      const targetPath = '/review_center/#/supplyAndDemand';
      window.open(targetPath, '_blank');
    },
    goServiceProviderRegister() {
      const targetPath = '/serviceProviderList';
      window.open(targetPath, '_blank');
    },
    async tianbao() {
      await this.query();
      let newToken = this.$cookies.get("api_token_new");
      if (!newToken) {
        // 未登录的话先登录
        this.$message.warning("您需要先登陆哦！")
        this.$router.push("/login");
      } else if (
          this.$store.state.isUsermessage.identity === "PERSONAL" ||
          this.$store.state.isUsermessage.identity === "ANONYMOUS"
      ) {
        // 没有经过企业认证的话去认证
        this.$confirm("请先进行企业资质认证!", "提示", {
          confirmButtonText: "去认证",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          window.sessionStorage.setItem("userServeId", "11");
          let routeData = this.$router.resolve({
            name: "userCenter",
            params: {
              userServeId: "11"
            }
          });
          window.open(routeData.href, "_target");
        });
        return false;
      } else {
        let flag = true; // true 表示当前列表全都提交过了，false表示有未提交的记录
        let uuid;
        if (this.dataList.length == 0) {
          // 若没有填报过，直接去填报
          let router = this.$router.resolve({
            path: "./serviceProviderApply",
            query: {}
          });
          window.open(router.href, "_blank");
        } else {
          // 有填报记录，判断是不是所有记录都生成报告了
          this.dataList.map(el => {
            // scope.row.status =='1'||scope.row.status == '4'
            if (el.status == "1" || el.status == "4") {
              flag = false;
            }
          });
          if (flag) {
            // 若当前记录全部提交，则查看列表。
            let routeData = this.$router.resolve({
              path: "/serviceProviderList",
            });
            window.open(routeData.href, "_blank");
          } else {
            // 若有未提交的记录,则继续这条信息去填写
            uuid = this.dataList.filter(el => el.status == "1" || el.status == "4")[0]
                .uuid;
            status = this.dataList.filter(el => el.status == "1" || el.status == "4")[0]
                .status;
            this.$nextTick(() => {
              // 如果当前有填报中的申请，即只保存未提交，则去该条继续编辑
              let routeData = this.$router.resolve({
                name: "serviceProviderApply",
                query: {
                  uuid,
                  status: status
                }
              });
              window.open(routeData.href, "_target");
            });
          }
        }
      }
    },
    query() {
      return new Promise((resolve, reject) => {
        if (!this.$store.state.isUsermessage.uuid) {
          resolve();
        }
        getServiceProviderRecord({
          userId: this.$store.state.isUsermessage.uuid,
          current: 1,
          pageSize: 10
        }).then(res => {
          if (res.list && res.list.length > 0) {
            this.dataList = res.list;
            this.total = res.total;
            resolve();
          } else {
            this.dataList = [];
            this.total = 0;
            resolve();
          }
        });
      });
    },
    getStatic() {
      demandInfoDataStatic().then(res => {
        if (res.success) {
          this.serviceInfo[0].num =  res.data.unitCount || 0;  // 入驻服务商
          this.serviceInfo[1].num =  res.data.count || 0;      // 发布需求
          this.serviceInfo[2].num =  res.data.totalBudget || 0;  // 需求金额
          this.serviceInfo[3].num =  res.data.totalUseCount || 0; // 响应需求
        } else {
          this.$message.error(res.message || '统计查询失败');
        }
      })
    },
    getDemandInfoList() {
      let params = {
        current: 1,
        pageSize: 8,
        status: 'REVIEW_PASS',
      }
      demandInfoQuery(params).then(res => {
        this.demandInfoList = res.list;
      })
    },
    getOptionsData() {
      //顶部背景图
      getDictionaryItem({
        code: "ZYC_BANNER"
      }).then(res => {
        if (res != null && res.length > 0) {
          this.headerBgUrl = res[0].value;
        } else {
          this.headerBgUrl = "";
        }
      });
    },
    // 获取服务商图标信息
    getServiceIcon() {
      getServiceIcon({
        status: 1,
        rec: 1,
        programUuid: ""
      }).then(res => {
        if (res && res.length > 0) {
          this.serviceList = res;
        } else {
          this.serviceList = [];
        }
      });
    },
    onClickLookMore() {},

    //众多优质服务商-查看更多
    onClickProviderMore() {
      let route = this.$router.resolve({
        path: "/providerList"
      });
      window.open(route.href, "_blank");
    },
    // 获取服务商详情
    serviceDetail(uuid) {
      let routeData = this.$router.resolve({
        path: "/providerDetail",
        query: {
          uuid: uuid
        }
      });
      window.open(routeData.href, "_blank");
    }
  }
};
</script>
<style lang="less" scoped>
.red-text {
  color: #FF0000;
}
.resourcePool {
  position: relative;
  top: -80px;
  margin-bottom: -80px;

  .curp {
    &:hover {
      cursor: pointer;
      color: #2d50a1;
    }
  }

  .top-banner-box {
    position: relative;
    .top-banner-img {
      height: 500px;
      width: 100%;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
      background: url('~@/assets/image/demandInfo_top_bg.png') no-repeat;
      background-size: cover;
      .top-banner-center {
        width: 1300px;
        height: 370px;
        position: relative;
      }
      .btn-row {
        margin-left: 80px;
        // background-color: white;
        display: flex;  
        position: absolute;
        bottom: 45px;
        transition: all 0.2s;
      }
      .btn {
        margin-right: 15px;
        width: 166px;
        height: 48px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 18px;
        font-weight: normal;
        color: #3672F6;
        border-radius: 4px;
        opacity: 1;
        background: rgba(255, 255, 255, 0.4);
        box-sizing: border-box;
        border: 1px solid #3672F6;
        cursor: pointer;
        user-select: none;
        &:first-child {
          background: linear-gradient(90deg, #2D50A1 0%, #6B8DDC 100%);
          color: #FFFFFF;
        }
      }
    }
  }

  .serviceCon {
    width: 1300px;
    height: 110px;
    margin: 0 auto;
    border-radius: 10px;
    opacity: 0.95;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    background-color: #fff;
    position: absolute;
    left: calc(50% - 650px);
    bottom: -55px;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;

    .serviceItem {
      width: 420px;
      height: auto;
      // border-right: 1px solid #d5dcec;
      display: flex;
      flex-flow: row nowrap;
      justify-content: center;
      align-items: center;

      &:last-child {
        border-right: none;
      }

      .serviceItem-bg {
        width: 60px;
        height: 70px;
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }

      .serviceItem-con {
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: flex-start;
        margin-left: 20px;

        .serviceItem-con-num {
            font-size: 24px;
            font-weight: bold;
            color: #2B2B2B;
        }

        .serviceItem-con-name {
          font-size: 20px;
          font-weight: 350;
        }
      }
    }
  }

}

.module {
  width: 100%;
  margin: auto;
  background-color: #fff;
  .module-title {
    font-size: 28px;
    font-weight: 600;
    text-align: center;
    margin: 20px 0;
  }
  .title {
    font-size: 24px;
    font-weight: bold;
    line-height: normal;
    letter-spacing: 0em;
    font-feature-settings: "kern" on;
    color: #2B2B2B;
  }
  &.hot {
    padding: 35px 48px;
    margin: auto auto 30px;
    border-radius: 12px;
    background: #F4F7FD;
    box-sizing: border-box;
    .module-title {
      margin-top: 42px;
    }
    .more-btn {
      margin: 0 auto;
      width: 200px;
      height: 50px;
      border-radius: 4px;
      opacity: 1;
      background: #FFFFFF;
      box-sizing: border-box;
      border: 1px solid #2D50A1;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #2D50A1;
      font-size: 16px;
      font-weight: normal;
      cursor: pointer;
    }
    .project-content {
      width: 1300px;
      margin: 25px auto 28px;
      display: flex;
      flex-wrap: wrap;
    }
    .project-item {
      margin-right: 20px;
      margin-bottom: 22px;
      position: relative;
      width: 310px;
      height: 392px;
      padding: 28px 17px 25px;
      border-radius: 8px;
      opacity: 1;
      background: #FFFFFF;
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
      font-size: 16px;
      font-weight: 350;
      line-height: normal;
      color: #2B2B2B;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      box-sizing: border-box;
      &:nth-of-type(4n) { 
        margin-right: 0;
      }
    }
    .flag {
      position: absolute;
      padding: 0 4px;
      box-sizing: border-box;
      top: 0;
      right: 0;
      width: 70px;
      height: 25px;
      border-radius: 0px 8px 0px 8px;
      opacity: 1;
      background: linear-gradient(270deg, #FF0000 0%, #FF7B00 100%);
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
      font-size: 14px;
      font-weight: 350;
      color: #FFFFFF;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden; /* 隐藏超出范围的内容 */
      span {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .title {
      margin: 3px 0;
      font-size: 24px;
      font-weight: bold;
      line-height: normal;
      white-space: nowrap; /* 禁止文本换行 */
      overflow: hidden; /* 隐藏超出范围的内容 */
      text-overflow: ellipsis; /* 使用省略号 */
    }
    .company {
      white-space: nowrap; /* 禁止文本换行 */
      overflow: hidden; /* 隐藏超出范围的内容 */
      text-overflow: ellipsis; /* 使用省略号 */
    }
    .introduction {
      padding: 11px 11px 14px;
      width: 276px;
      height: 65px;
      border-radius: 4px;
      background: #eaedf5;
      box-sizing: border-box;
      line-height: 1.52;
      display: -webkit-box; /* 设置为WebKit内核的弹性盒子模型 */
      -webkit-box-orient: vertical; /* 垂直排列 */
      -webkit-line-clamp: 2; /* 限制显示三行 */
      overflow: hidden; /* 隐藏超出范围的内容 */
      text-overflow: ellipsis; /* 使用省略号 */
    }
    .btn-row {
      margin-top: 10px;
      padding-top: 14px;
      border-top: 1px solid #CBCBCB;
      .btn {
        width: 100%;
        height: 48px;
        border-radius: 4px;
        background: linear-gradient(90deg, #2D50A1 0%, #6B8DDC 100%);
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  &.resource {
    .img-list {
      margin: 0 auto;
      width: 1300px;
      display: flex;
      justify-content: space-between;
    }
    .img-item1, .img-item2, .img-item3, .img-item4 {
      width: 310px;
      height: 187px;
      background-size: contain;
    }
    .img-item1 {
      background: url("../../assets/image/demandInfo_resources1.png") no-repeat
      center center/100% 100%;
    }
    .img-item2 {
      background: url("../../assets/image/demandInfo_resources2.png") no-repeat
      center center/100% 100%;
    }
    .img-item3 {
      background: url("../../assets/image/demandInfo_resources3.png") no-repeat
      center center/100% 100%;
    }
    .img-item4 {
      background: url("../../assets/image/demandInfo_resources4.png") no-repeat
      center center/100% 100%;
    }
  }
  .product-content {
    padding-bottom: 10px;
    position: relative;
    width: 1300px;
    margin: auto !important;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .row {
      display: flex;
      justify-content: space-between;
      &:first-of-type {
        margin-bottom: 20px;
      }
    }
  }
  .module-content.scene {
    display: flex;
    .scene-item {
      width: 25%;
      padding: 0 40px;
    }
    .title {
      margin: 14px 0;
    }
    .text {
      font-size: 18px;
      font-weight: 350;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 4;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .btn  {
      margin: 14px 0;
      color: #2D50A1;
      font-size: 18px;
      font-weight: 350;
    }
  }
}

.btn {
  cursor: pointer;
}
/deep/ .el-carousel__arrow--left {
  left: 90px;
}

/deep/ .el-carousel__arrow--right {
  right: 90px;
}
</style>



// WEBPACK FOOTER //
// src/components/demandInfo/index.vue